import clsx from "clsx";
import React from "react";

type SidebarToggleIconProps = {
  collapsed: boolean;
  side?: "left" | "right";
  className?: string;
};

/**
 * One sidebar glyph with two faces: the solid rail says that the panel is
 * visible, while the narrow rail says that it is tucked away. Keeping both
 * faces in one SVG lets the rail ease between them instead of swapping icons.
 */
const SidebarToggleIcon = ({ collapsed, side = "right", className }: SidebarToggleIconProps) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={clsx("h-6 w-6", className)}
    aria-hidden="true"
  >
    <rect x="3" y="3" width="18" height="18" rx="4" stroke="currentColor" strokeWidth="1.8" />
    <rect
      x={side === "left" ? "5" : "15"}
      y="6"
      width="4"
      height="12"
      rx="1.35"
      fill="currentColor"
      style={{ transformBox: "fill-box" }}
      className={clsx(
        side === "left" ? "origin-left" : "origin-right",
        "transition-transform duration-200 ease-out motion-reduce:transition-none",
        collapsed ? "scale-x-[0.375]" : "scale-x-100",
      )}
    />
  </svg>
);

export default SidebarToggleIcon;
